module.exports = __webpack_public_path__ + "img/borderless_userpic.svg";